import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CutIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.02 16.44V5.64H8.92V4.08H18.58V16.44H17.02ZM5.42 7.48H6.98V9.04H5.42V7.48ZM8.12 7.48H9.68V9.04H8.12V7.48ZM10.82 7.48H12.38V9.04H10.82V7.48ZM13.52 7.48H15.08V9.04H13.52V7.48ZM13.52 10.18H15.08V11.74H13.52V10.18ZM6.98 11.74H5.42V10.18H6.98V11.74ZM13.52 12.88H15.08V14.44H13.52V12.88ZM6.98 14.44H5.42V12.88H6.98V14.44ZM13.52 15.58H15.08V17.14H13.52V15.58ZM6.98 17.14H5.42V15.58H6.98V17.14ZM13.52 18.28H15.08V19.84H13.52V18.28ZM12.38 19.84H10.82V18.28H12.38V19.84ZM9.68 19.84H8.12V18.28H9.68V19.84ZM6.98 19.84H5.42V18.28H6.98V19.84Z" />
    </SvgIcon>
  );
});
